import {
  PostDataCommentReplyResponse,
  ResponseWithData,
} from '@frontend/sorghum/interface';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { COMMENT_REPLY_DATA } from '../apis';

async function postDataCommentReplyListData(
  ids: string[],
  channelID?: string,
): Promise<ResponseWithData<PostDataCommentReplyResponse>> {
  return axios
    .post(COMMENT_REPLY_DATA, {
      projectChannelId: channelID,
      ids,
    })
    .then((res) => {
      return res.data;
    });
}

export function usePostDataCommentReply({
  ids,
  channelID,
}: {
  ids: string[];
  channelID?: string;
}) {
  return useQuery({
    queryKey: ['post-data-comment-reply', { channelID, ids }],
    // 失敗不丟給全域 error boundary（會整頁白屏），也不再吞掉；
    // 由呼叫端用 isError 決定怎麼提示（數據頁 toast、列表頁維持顯示「-」）
    useErrorBoundary: false,
    // 只在失敗狀態下不要於視窗 focus 重打（這支 API 在大專案曾跑 30–60 秒，重打只會放大 rum 負載並重複跳 toast）；
    // 成功的資料仍照預設 staleTime 在 focus 時更新，維持「即時數據」
    refetchOnWindowFocus: (query) => query.state.status !== 'error',
    queryFn: () => {
      if (channelID && ids.length > 0) {
        return postDataCommentReplyListData(ids, channelID);
      } else {
        return {};
      }
    },
  });
}
